import styled from "styled-components";
import { CartGroupContainer } from "@cart-ui/components/cart-group";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const CARD_SHADOW = "0 0 4px rgba(2, 6, 12, 0.08)";

export const Container = styled(CartGroupContainer)(({ theme }) => ({
    margin: `0 ${theme.spacing.medium} ${theme.spacing.large} ${theme.spacing.medium} !important`,
    padding: `${theme.spacing.xxxSmall} !important`,
    boxShadow: CARD_SHADOW,
    overflow: "visible",
}));

export const Header = styled.div<{ $background?: string }>(({ theme, $background }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing.small,
    minHeight: 57,
    paddingLeft: theme.spacing.medium,
    background: $background,
    borderTopRightRadius: theme.spacing.medium,
    borderTopLeftRadius: theme.spacing.medium,
}));

export const HeaderText = styled.div({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minWidth: 0,
});

export const HeaderImage = styled.div({
    flexShrink: 0,
    width: 64,
    height: 64,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
});

export const Body = styled.div({
    display: "flex",
    flexDirection: "column",
    gap: 0,
    position: "relative",
    overflow: "visible",
});

export const DeliveryTypeRowWrap = styled.div({
    position: "relative",
    zIndex: 10,
    width: "100%",
});

export const TooltipOverlay = styled.div(({ theme }) => ({
    position: "absolute",
    top: "100%",
    left: theme.spacing.xxLarge,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginTop: `calc(${theme.spacing.small} * -1)`,
    zIndex: 11,
    pointerEvents: "none",
}));

export const TooltipInteract = styled.div(({ theme }) => ({
    pointerEvents: "auto",
    maxWidth: "100%",
    marginLeft: theme.spacing.xSmall,
}));

export const InfoRow = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing.small,
    padding: theme.spacing.medium,
    width: "100%",
}));

export const InfoRowMain = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    width: "100%",
    gap: theme.spacing.small,
}));

export const IconWell = styled.div<{ $iconBackground?: string }>(({ $iconBackground }) => ({
    flexShrink: 0,
    width: 20,
    height: 20,
    borderRadius: 4,
    backgroundColor: $iconBackground,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 2,
}));

export const RowText = styled.div({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "75%",
});

export const RowDivider = styled.div(({ theme }) => ({
    height: 1,
    backgroundColor: theme.colors.light.border_Tertiary,
}));

export const Cta = styled(Text)(({ theme }) => ({
    flexShrink: 0,
    paddingLeft: theme.spacing.xSmall,
    cursor: "pointer",
    alignSelf: "center",
}));
